// src/auth/roles.js

export const ROLES = {
    ADMIN_USERS_MANAGE: "Admin.Users.Manage",
    ADMIN_ROLES_MANAGE: "Admin.Roles.Manage",
    NEWS_VIEW: "News.View",
    TRADING_VIEW: "Trading.View",
};

// Rollen aus localStorage lesen
export const getUserRoles = () => {
    try {
        const raw = localStorage.getItem("roles");
        if (!raw) return [];

        const parsed = JSON.parse(raw);

        if (!Array.isArray(parsed)) return [];

        return parsed;
    } catch {
        return [];
    }
};

// einzelne Rolle pr�fen
export const hasRole = (role) => {
    const roles = getUserRoles();
    return roles.includes(role);
};

// mindestens eine Rolle pr�fen
export const hasAnyRole = (userRoles, requiredRoles) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;

    if (!Array.isArray(userRoles)) return false;

    return requiredRoles.some((r) => userRoles.includes(r));
};

// Admin Shortcut
export const isAdmin = () => {
    const roles = getUserRoles();

    return (
        roles.includes(ROLES.ADMIN_USERS_MANAGE) ||
        roles.includes(ROLES.ADMIN_ROLES_MANAGE)
    );
};